import * as React from 'react';
import { Link, withRouter } from 'react-router';
import { get } from 'lodash';
import FK_LOGO from 'images/fk-logo.png';
import FK_LOGO_EXPLORE_PLUS from 'images/flipkartplus/flipkart-plus.png';
import FK_LOGO_PLUS from 'images/flipkartplus/fk-plus.png';
import PLUS_BRAND from 'images/flipkartplus/plus.png';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { URLConstants } from 'constants/URLConstants';
import { LOCKIN_NON_LOGGED_IN, LOCKIN_ACTIVE, LOCKIN_ACTIVATE_ELIGIBLE, LOCKIN_INACTIVE, LOCKIN_EXPIRED, LOCKIN_UNKNOWN } from 'constants/LoginConstants';
import GroceryLogo from 'images/grocery/grocery-logo.svg';
import defaultStyles from './Logo.css';
export class Logo extends React.Component {
    constructor(props) {
        super(props);
        this.renderVipSubTitle = (subTitleText, styles) => {
            return subTitleText ? (<Link to={URLConstants.VIP_LANDING_URL} className={styles['vip-sub-title']}>
				{subTitleText} <span className={styles['text']}>{stringTemplate('vipPlus')}</span>
				<img width={10} src={PLUS_BRAND}/>
			</Link>) : null;
        };
        this.getLogoAttributes = () => {
            const { userState, cobrandedConfig, cobrandedStore, isGrocery } = this.props;
            const cobrandedLogo = get(cobrandedConfig, [cobrandedStore, 'logo']);
            const lockInState = get(userState, ['lockinResponse', 'userMembershipState']);
            if (isGrocery) {
                return {
                    src: GroceryLogo,
                    width: 76
                };
            }
            if (cobrandedStore) {
                return {
                    src: cobrandedLogo || FK_LOGO,
                    width: 110
                };
            }
            switch (lockInState) {
                case LOCKIN_ACTIVE:
                    return {
                        src: FK_LOGO_PLUS,
                        width: 100
                    };
                case LOCKIN_ACTIVATE_ELIGIBLE:
                    return {
                        src: FK_LOGO_EXPLORE_PLUS,
                        width: 75,
                        subTitleText: stringTemplate('vipJoin')
                    };
                case LOCKIN_INACTIVE:
                case LOCKIN_EXPIRED:
                case LOCKIN_NON_LOGGED_IN:
                    return {
                        src: FK_LOGO_EXPLORE_PLUS,
                        width: 75,
                        subTitleText: stringTemplate('vipExplore')
                    };
                case LOCKIN_UNKNOWN:
                default:
                    return {
                        src: FK_LOGO,
                        width: 110
                    };
            }
        };
        this.renderLogo = (styles, logoLink) => {
            const { src = '', width, subTitleText } = this.getLogoAttributes();
            return (<div className={styles['logo']}>
				<Link to={logoLink}>
					<img width={width} src={src} alt="Flipkart" title="Flipkart" data-aid="header_logo_flipkart" className={styles['brand-logo']}/>
				</Link>
				{this.renderVipSubTitle(subTitleText, styles)}
			</div>);
        };
    }
    render() {
        const { coBrandStyles, isGrocery } = this.props;
        const styles = Object.assign({}, defaultStyles, coBrandStyles);
        const logoLink = isGrocery ? URLConstants.GROCERY_STORE_LINK : '/';
        return this.renderLogo(styles, logoLink);
    }
}
export default withRouter(Logo);
